import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { stateAction } from "../Store/Actions/AuthAction";
import { saveAssignmentWithSchedule } from "../Store/Actions/OutboundAction";
import { clearSessionCall } from "../Store/SIP/call";

import {
  GET_NEXT_ASSIGNMENT,
  SET_AUTO_DIAL,
  SET_DIAL_MODE,
  SET_PENDING_STATUS_REASON,
} from "../Store/Types/AgentTypes";

import { RESET_CALL_STATE, SET_GO_TO_ACW } from "../Store/Types/CallTypes";

const RenderTimeout = ({ ACWDuration }) => {
  const [timeLeft, setTimeLeft] = useState(ACWDuration); // Set initial countdown time
  const dispatch = useDispatch();
  const { pendingStatusReason, dialMode } = useSelector((state) => state.agent);
  const { myInfo } = useSelector((state) => state.auth);

  const {
    callTime,
    campaignID,
    contactID,
    phoneNumber,
    phoneTypeID,
    stateCall,
  } = useSelector((state) => state.call);

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft((prevSeconds) => prevSeconds - 1);
      }, 1000);

      return () => clearInterval(timerId);
    } else if (timeLeft <= 1) {
      handleSubmit();
      alert("Result Submitted");
    }
  }, [timeLeft]);

  const handleSubmit = () => {
    const payload = {
      agentid: myInfo.user.AgentID,
      phoneno: phoneNumber,
      phonetype: phoneTypeID, // PhoneTypeID?
      uniqueid: stateCall.UniqueID ? stateCall.UniqueID : 0, // Unique ID? (state call)
      campaignid: campaignID,
      contactid: contactID,
      callsource: "AUTOMATICCALL", // WHATSAPP || AUTOMATICCALL || MANUALCALL
      calltime: callTime.toISOString(), // Tanggal telepon
      actioncodereason: "No Interaction Status",
      actioncode: "_SNO",
      nextaction: "HANGUP", //
      trycount: 1, // default 1;
      remarks: "", // Notes
      followupdate: null,
      duration: moment().diff(callTime, "seconds"), // dari call time sampai save, seconds
      recordingfile: stateCall.RecFileName,
      customdatajson: null, // Custom data
      wa_id: null, // kalo dari WA
    };

    saveAssignmentWithSchedule(payload)
      .then((response) => {
        if (response.status) {
          dispatch({ type: SET_GO_TO_ACW, payload: false });

          toast.success("Saved successfully", {
            autoClose: 3000,

            onClose: () => {
              if (dialMode === "progressive" && pendingStatusReason === "") {
                dispatch({ type: GET_NEXT_ASSIGNMENT });
              } else if (
                dialMode === "predictive" &&
                pendingStatusReason === ""
              ) {
                dispatch({ type: SET_AUTO_DIAL, payload: false });

                dispatch({
                  type: SET_DIAL_MODE,
                  payload: "",
                });
              }
            },
          });

          dispatch(clearSessionCall());
          dispatch({ type: RESET_CALL_STATE });

          if (pendingStatusReason !== "") {
            // If there is a pending status change, set status to the pending status
            dispatch(stateAction("AUX", pendingStatusReason, "ACW", "Orange"));

            dispatch({ type: SET_PENDING_STATUS_REASON, payload: "" });
            dispatch({ type: SET_AUTO_DIAL, payload: false });
          } else {
            // Else, change status to READY
            dispatch(stateAction("READY", undefined, "ACW", "Green"));
          }
        } else {
          console.log("error", response.error);
          toast.error("else - Error saving result.", { autoClose: 3000 });
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Error saving result.", { autoClose: 3000 });
      });
  };

  return (
    <div className="timer_container">
      <div className="timer_information">
        <div className="timer_information_text">{timeLeft}</div>
      </div>
    </div>
  );
};

export default RenderTimeout;
